import React from "react";
import { Button } from "@/components/Button/Button";
import LoadingIndicator from "@/components/LoadingIndicator/LoadingIndicator";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import RecurringEmailCard from "@/modules/emailManagement/features/RecurringEmailManagement/components/RecurringEmailCard/RecurringEmailCard";
import { useRecurringEmailList } from "@/modules/emailManagement/features/RecurringEmailManagement/hooks/useRecurringEmailList";

const RecurringEmailList: React.FC = () => {
  const {
    recurringEmails,
    isLoading,
    decrementSubscriberCount,
    canAddSubscribers,
    goToAddSubscriber,
  } = useRecurringEmailList();

  return (
    <MainPageWrapper
      actions={
        canAddSubscribers && (
          <Button onClick={goToAddSubscriber}>Add Subscriber</Button>
        )
      }
      subtitle="Scheduled emails and who receives them."
      title="Recurring Emails"
    >
      {isLoading && (
        <div className="flex items-center justify-center min-h-[300px]">
          <LoadingIndicator isFullScreen={false} />
        </div>
      )}

      <div className="space-y-4">
        {recurringEmails.map((recurringEmail) => (
          <RecurringEmailCard
            key={recurringEmail.recurringEmail}
            onUnsubscribed={() =>
              decrementSubscriberCount(recurringEmail.recurringEmail)
            }
            recurringEmail={recurringEmail}
          />
        ))}
      </div>
    </MainPageWrapper>
  );
};

export default RecurringEmailList;
